import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { useSnackbar } from '../../../../../helpers/hooks/useSnackbar'

const DetailsItem = ({ data, title }) => {
  const { t } = useTranslation(['rewards-dashboard'])
  const { displaySnackbar } = useSnackbar()

  const handleCopy = (isCopyAvailable, value) => {
    if (!isCopyAvailable) {
      return
    }

    navigator.clipboard.writeText(value)
    displaySnackbar(t('rewards-dashboard:detailsItem.copiedToClipboard', { value }))
  }

  return (
    <div className="details-item-container">
      {title && <span className="details-title">{title}</span>}
      <table className="details-item">
        <tbody>
          {data.map(({ hidden, newLine, value, title, copyAble }, index) => {
            if (hidden) {
              return null
            }
            const isCopyAvailable = copyAble && value !== '-'
            return (
              <tr key={`${+index}_${value}`}>
                <td>
                  {title}
                  {newLine && <span>{value}</span>}
                </td>
                {!newLine && (
                  <td
                    style={{ cursor: isCopyAvailable ? 'pointer' : 'initial' }}
                    onClick={() => handleCopy(isCopyAvailable, value)}
                  >
                    {value}
                  </td>
                )}
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}

DetailsItem.propTypes = {
  data: PropTypes.array,
  title: PropTypes.string,
}

export default DetailsItem
